import { useCallback } from "react";

import { losPipelineApi } from "../../api/losPipelineApi";
import { dealsForTab } from "../../constants/pipelineTabs";
import { loanSubStatusOptionsMap } from "../../constants/selectOptions/selectOptionsLoanStatus";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import PipelineTableScreen from "./PipelineTableScreen";

// Closed Loans tab (Closing → Closed Loans in the nav). Same table as Clear to
// Close, sliced to the closed bucket instead: pipeline "Closed" OR loanStatus
// "Closed" — the POST_CLOSE predicate in constants/pipelineTabs.js.
//
// Every loan here shares the "Closed" loanStatus, so — exactly like Clear to
// Close — the status switcher slices by subStatus (Funded / Funded with Post
// Close Conditions) rather than by status.
const CLOSED_SUBSTATUSES = loanSubStatusOptionsMap.Closed;

const ClosedLoansPipelineScreen = () => {
  useDocumentTitle("Closed Loans");
  const fetchData = useCallback(({ onSuccessFn, onFailFn, onErrorFn }) => {
    const onError = onFailFn || onErrorFn || (() => {});
    losPipelineApi
      .getUnderwritingPipeline()
      .then((deals) => onSuccessFn?.(dealsForTab(deals, "POST_CLOSE")))
      .catch(onError);
  }, []);

  return (
    <PipelineTableScreen
      title="Closed Loans"
      // Its own namespace so saved layouts / remembered views don't collide
      // with the Clear to Close board.
      storageKeyPrefix="closed-loans-pipeline"
      fetchData={fetchData}
      statusField="subStatus"
      statusOptions={CLOSED_SUBSTATUSES}
    />
  );
};

export default ClosedLoansPipelineScreen;
